import { render, staticRenderFns } from "./TwHeader.vue?vue&type=template&id=1cf868b6&scoped=true&"
import script from "./TwHeader.vue?vue&type=script&lang=js&"
export * from "./TwHeader.vue?vue&type=script&lang=js&"
import style0 from "./TwHeader.vue?vue&type=style&index=0&id=1cf868b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf868b6",
  null
  
)

export default component.exports